// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88417572","455":"5e3753cc","977":"3c420a77"}[chunkId] + ".chunk.js";
};